import { useMutation } from '@tanstack/react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { startEntraIdInitialSync } from '../../api/portalServices';
import { useErrorContext } from '../../errorHandler/context/ErrorContext';
import { type ApiError, AppError } from '../../errorHandler/errors';
import { PortalPath } from '../PortalRoutes';

const useEntraIdInitialSync = () => {
  const { emitError } = useErrorContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useMutation({
    mutationFn: async (tenantId: string) => {
      await startEntraIdInitialSync(tenantId);
    },
    onSuccess: async () => {
      console.log('Entra ID initial sync completed');
      const params = new URLSearchParams(searchParams);
      navigate({ pathname: PortalPath.SETTINGS, search: `?${params.toString()}` });
    },
    onError: (e: Error) => {
      console.log('Entra ID initial sync failed', e);
      const apiError = e as unknown as ApiError;
      emitError(new AppError(apiError));
    },
  });
};

export default useEntraIdInitialSync;
